/* unplugin-vue-components disabled */import { render } from "./share-modal.vue?vue&type=template&id=304cf346&scoped=true"
import script from "./share-modal.vue?vue&type=script&lang=js"
export * from "./share-modal.vue?vue&type=script&lang=js"

import "./share-modal.vue?vue&type=style&index=0&id=304cf346&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-304cf346"],['__file',"src/pages/share-prompt/share-modal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "304cf346"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('304cf346', __exports__)) {
    api.reload('304cf346', __exports__)
  }
  
  module.hot.accept("./share-modal.vue?vue&type=template&id=304cf346&scoped=true", () => {
    api.rerender('304cf346', render)
  })

}


export default __exports__